import { QueryResult } from '@apollo/client';

import { ConversationIcon } from '@treams/treams-icons';
import { EvaluationSubmission, OutgoingEvaluationSubmissionsQuery } from '@treams/treams-network';
import { CardList } from '@treams/treams-ui';

import ConversationCard from './ConversationCard';

export default function OutgoingConversationsList(props: {
	query: QueryResult<OutgoingEvaluationSubmissionsQuery>;
	archivedQuery: QueryResult<OutgoingEvaluationSubmissionsQuery>;
	fetchArchived: () => void;
}) {
	return (
		<CardList
			translationName="conversations.outgoing"
			query={props.query}
			archivedQuery={props.archivedQuery}
			fetchArchived={props.fetchArchived}
			path="user.outgoingEvaluationSubmissions"
			skeletonRepeat={2}
			icon={<ConversationIcon />}
			renderCard={(item: EvaluationSubmission) => (
				<ConversationCard key={item.id} submission={item} />
			)}
			renderSkeleton={() => <ConversationCard.Skeleton />}
		/>
	);
}
